import React from 'react';
import { FormikProps } from 'formik';
import { FormField } from '../../../../../global/components/form-element/form-field';
import { DeathOfChildWizard } from '../wizard/death-of-child-wizard';


interface Props {
	formProps: FormikProps<any>;
	wizard: DeathOfChildWizard;
}
export function DeathOfChildAgreements(props: Props) {
	const {
		formProps,
		wizard,
	} = props;
	const relationshipsProps = wizard?.getRelationShipSettings();

	return (
		<>
			<FormField
				name='checkbox1'
				label={relationshipsProps?.deathOfChildCheckBoxDescription}
				component='checkBox'
				touched={formProps.touched}
				errors={formProps.errors}
				value={formProps?.values?.checkbox1 ?? false}
				checked={formProps?.values?.checkbox1 ?? false}
			/>			
		</>
	);
}